import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import Swal from 'sweetalert2';

import { cn } from '../helpers';
import { getToken } from '../../data/token/repositories/tokenRepository';
import { arrGetCompanyApplicationMappingMain } from '../../models/company/CompanyApplicationMapping';
import { useLoader, useStore } from '../hooks';
import { useHistory } from 'react-router';

type Props = {
    dataItem: arrGetCompanyApplicationMappingMain;
    //mode: string;
};

function CardApplication(props: Props) {
    const { dataItem /*, mode*/ } = props;
    const isInactive = dataItem.application_status === 'inactive';
    const url = isInactive ? undefined : dataItem.application_ingress;

    const { tokenStore, userCompanyStore, subDashboardStore } = useStore();
    //const { token } = tokenStore;
    const { mode, citizenId, email, firstName, lastName, currentUserCompanyMapping } =
        userCompanyStore;
    const companyToken = subDashboardStore.selectedCompanyToken;
    const screenLoader = useLoader();

    const windowRef = useRef<ReturnType<typeof window.open>>();

    //useEffect(() => {
    //    getUserInformation('', '', 'active');
    //}, []);

    //const getUserInformation = useCallback(
    //    async (sid: string, citizenId: string, status: string) => {
    //        await userCompanyStore.fetchUserCompany(sid, citizenId, status);
    //    },
    //    []
    //);

    const handlePostViaForm = (url: string, token: string) => {
        const postData = {
            token: token,
        };

        //const targetUrl = url; // URL ที่จะรับ POST request
        const targetUrl = 'https://localhost:8082/';

        // สร้างฟอร์มแบบไดนามิก
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = targetUrl;
        form.target = '_blank'; // ทำให้ฟอร์มถูก submit ไปยังแท็บใหม่

        // เพิ่ม input fields สำหรับข้อมูลแต่ละตัว
        for (const key in postData) {
            if (postData.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = postData[key];
                form.appendChild(hiddenField);
            }
        }

        // เพิ่มฟอร์มลงใน body ชั่วคราว (เพื่อที่เบราว์เซอร์จะสามารถ submit ได้)
        document.body.appendChild(form);

        // ส่งฟอร์ม
        form.submit();

        // ลบฟอร์มออกจาก DOM หลังจากที่ถูก submit แล้ว
        document.body.removeChild(form);
    };

    const openApplication = async (isInactive: boolean, url = '') => {
        try {
            if (isInactive) {
                throw new Error('คุณไม่ได้รับอนุญาติให้ใช้แอปพลิเคชันนี้');
            }

            if (!companyToken) {
                throw new Error('ไม่พบบริษัทนี้');
            }

            const notifyMessage = currentUserCompanyMapping.find(
                userCompany =>
                    userCompany.sid === dataItem.company_id &&
                    userCompany.platform_id === dataItem.platform_id
            )?.notify_message_when_open;
            if (notifyMessage) {
                const result = await Swal.fire({
                    title: notifyMessage,
                    icon: 'warning',
                    showDenyButton: true,
                    denyButtonText: 'ไม่ต้องการ',
                    confirmButtonText: 'ต้องการ'
                });

                if (!result.isConfirmed || result.isDenied || result.isDismissed) {
                    return;
                }
            }

            screenLoader.show();

            const userId = citizenId;
            const mode = localStorage.getItem('mode') || 'web';
            //if (companyToken != '1IbuASmpqIapjmhVfzcLF4XPVY9'
            //    && companyToken != '2KlP5DjCQeyOSgyAH0vNezHzu18') {
            //    userId = citizenId.split('@')[0];
            //}

            const [error, getTokenResponse] = await getToken({
                company_token: companyToken,
                citizen_id: userId,
                email: email,
                first_name: firstName,
                last_name: lastName,
                mode: mode,
                sid: dataItem.group_name,
                application: dataItem.application_name.split('\n').join(' ')
            });

            if (error) {
                console.log(error);

                throw new Error(
                    error.message
                    // 'We are unable to process your request at this time. Please try again.'
                );
            }

            //console.log("[Debug] token", getTokenResponse[1])
            // const composedUrlWithToken = url + '?token=' + getTokenResponse;

             console.log(dataItem.method);
            // console.log(dataItem.application_type);

            if (dataItem.application_type == 'web') {
                const composedUrlWithToken =
                    url + (url.indexOf('?') > -1 ? '&token=' : '?token=') + getTokenResponse;

                if (mode == 'gui') {
                    var jResWeb = {
                        action: 'LOGIN_SUCCESS',
                        token: getTokenResponse,
                        citizen_id: citizenId,
                        select_server: {
                            system_type: 'WEB',
                            //system_id: value.sid,
                            system_name: dataItem.application_name,
                            //endpoint: value.ingress + '?token=' + result.token
                            endpoint: composedUrlWithToken
                            //host: value.host,
                            //port: value.port
                        }
                    };

                    const response = JSON.stringify(jResWeb);
                    (window as any).chrome.webview.postMessage(response);

                    return;
                }

                const userAgent = window.navigator.userAgent;

                const isiOS =
                    userAgent.match(/Macintosh/i) ||
                    userAgent.match(/iPad/i) ||
                    userAgent.match(/iPhone/i);
                const isiOSSafari =
                    isiOS &&
                    userAgent.match(/WebKit/i) &&
                    !userAgent.match(/CriOS/i) &&
                    !userAgent.match(/EdgiOS/i) &&
                    !userAgent.match(/Chrome/i) &&
                    !userAgent.match(/Edg/i);
                const isAndroid = /(android)/i.test(userAgent);
                const isMobile = /(mobile)/i.test(userAgent);
                if (isiOSSafari || isAndroid || isMobile) {
                    window.location.href = composedUrlWithToken;
                    return;
                }

                console.log(dataItem);

                if (dataItem.method == 'post') {
                    handlePostViaForm(url, getTokenResponse);
                } else {
                    windowRef.current = window.open();
                    windowRef.current && (windowRef.current.location = composedUrlWithToken);
                }                
            } else if (dataItem.application_type == 'gui') {
                var jResGui = {
                    action: 'LOGIN_SUCCESS',
                    token: getTokenResponse,
                    citizen_id: citizenId,
                    select_server: {
                        system_type: 'GUI',
                        system_id: dataItem.application_sid,
                        system_name: dataItem.application_name.replace('\n', ' '),
                        host: dataItem.application_host,
                        port: dataItem.application_port
                    }
                };

                var res = JSON.stringify(jResGui);

                (window as any).chrome.webview.postMessage(res);
            } else {
                throw new Error(
                    'Application Type ' + dataItem.application_type + ' does not support'
                );
            }
        } catch (error) {
            if (error instanceof Error) {
                // Swal.fire({
                //     title: '',
                //     text: error.message,
                //     icon: 'warning',
                //     confirmButtonColor: '#3085d6',
                //     confirmButtonText: 'OK',
                //     allowOutsideClick: false
                // });
                screenLoader.hide();
                const result = await Swal.fire({
                    title: '',
                    text: error.message,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Retry',
                    showCancelButton: true,
                    cancelButtonText: 'OK',
                    allowOutsideClick: false
                });

                if (result.isConfirmed) {
                    openApplication(isInactive, url);
                }
            }
        } finally {
            screenLoader.hide();
        }
    };

    const openApplicationOnNewTab = useCallback(() => {
        //windowRef.current = window.open();
        openApplication(isInactive, url);
    }, [isInactive, url, openApplication]);

    return (
        <div
            tabIndex={0}
            className={cn(
                'group relative m-[5px] inline-flex h-[145px] w-[110px] flex-col overflow-hidden rounded-[6px] px-[5px] py-[10px] shadow-[5px_7px_19px_-3px_#00000040] transition-[box-shadow,transform]',
                dataItem.application_status !== 'inactive'
                    ? `hover:[0_45px_65px_rgba(0,0,0,0.50),_0_35px_22px_rgba(0,0,0,0.16)] focus:[0_45px_65px_rgba(0,0,0,0.50),_0_35px_22px_rgba(0,0,0,0.16)] cursor-pointer bg-white hover:scale-105 focus:scale-105 focus:shadow-gray-500`
                    : 'cursor-not-allowed bg-[#7A7A7A40] grayscale'
            )}
            onClick={openApplicationOnNewTab}
        >
            <div className="flex flex-1 flex-col items-center justify-end pb-[8px]">
                <img
                    className="h-9 w-9 object-contain"
                    src={dataItem.application_img_url}
                    alt={dataItem.application_name}
                />
            </div>
            <div className="flex w-full flex-col items-center">
                <span
                    className={cn(
                        'flex h-[45px] w-full items-start justify-center whitespace-pre-line break-words text-center text-[11px] leading-[15px] text-[#0C0B0B] transition-[text-shadow] group-focus:[text-shadow:_0px_0px_1px_currentColor]',
                        dataItem.application_status === 'inactive' ? 'text-[#7A7A7A]' : ''
                    )}
                >
                    <span className="line-clamp-3">{dataItem.application_name}</span>
                </span>
                <div className="flex h-[13px] w-full items-center justify-center">
                    {dataItem.description && (
                        <span className="whitespace-pre-line break-words text-center text-[7px] leading-[13px] text-[#0C0B0B] transition-[text-shadow] group-focus:[text-shadow:_0px_0px_1px_currentColor]">
                            {dataItem.description}
                        </span>
                    )}
                </div>
                <div className="mt-[2px] flex h-[14px] w-full items-center justify-center">
                    {dataItem.application_status === 'inactive' && (
                        <span className="text-[10px] font-semibold leading-none text-[#7f7171]">
                            INACTIVE
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default observer(CardApplication);
